import { TicketList } from "../TicketList/TicketList";
import { ProjectForTicket } from "../ProjectForTicket/ProjectForTicket";
import { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';


const TicketPage = () => {

    const path = useParams()
    const navigate = useNavigate()
    const [selectedProject, setSelectedProject] = useState(null)

     useEffect(() => {
        if (path['*'] === '') {
            navigate('/ticket/project-for-ticket/project')
            setSelectedProject(null)
        }
    }, [path])

    return (
        <Routes>
            <Route path='project-for-ticket/*' element={<ProjectForTicket selectedProject={selectedProject} setSelectedProject={(e) => setSelectedProject(e)}/>} />
            <Route path='ticket-list/*' element={<TicketList setSelectedProjectAbove={e => setSelectedProject(e)} />} />
        </Routes>
    )
}

export { TicketPage }